import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { NotificationPage } from '../../app/components/pages/account/notification/notification.page';

@Injectable({
  providedIn: 'root'
})

export class AccountNotificationsGuard implements CanDeactivate<NotificationPage> {
  canDeactivate(component:NotificationPage): boolean {
    if(component.isModified()){
      component.showSaveAlert();
      return false;
    }
    return true;
  }
}
